<template lang="pug">
  .modal.active
    .modal-overlay
    .modal-container
      .modal-header
        button.btn.btn-clear.float-right(@click='cancel')
        .modal-title.h5 Intake Form
      .modal-body
        .content
          blockquote.message.info
            b About this form:
            |  The resource you are editing will be shown to anyone who generates a checklist matching any of the following criteria.

          intake-form

      .modal-footer
        button.btn.float-left(@click='clearConfig') Clear Config
        button.btn.btn-link(@click='cancel') Cancel
        button.btn.btn-primary.ml-1(@click='closeModal') Save Config
</template>





<script>
  import IntakeForm from '@/components/checklist/Intake'
  import {mapState} from 'vuex'
  import init from '@/store/init'

  export default {
    name: 'modal-intake-config',

    components: {
      IntakeForm
    },

    computed: mapState([
      'intakeConfig'
    ]),

    mounted () {
      this.initIntakeConfig = Object.assign({}, this.intakeConfig)
    },

    data () {
      return {
        initIntakeConfig: Object.assign({}, init.intakeConfig)
      }
    },

    methods: {
      closeModal () {
        this.$store.commit('toggleIntakeConfigModal')
      },

      // Resets the intake form to what it was when we loaded it
      cancel () {
        this.$store.commit('setIntakeConfig', this.initIntakeConfig)
        this.closeModal()
      },

      clearConfig () {
        this.$store.commit('clearIntakeConfig')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/IntakeConfig.vue